import { Reducer } from "redux";
import * as authActions from "./authActions";
import { Organization } from "../../model/Organization";
import { Me } from "../../model/Me";

export interface AuthState {
  /**
   * is request in flight
   */
  isAuthenticating: boolean;

  /**
   * is user authenticated
   */
  isAuthenticated: boolean;

  /**
   * reason from server for rejecting login request
   */
  errors: Array<{ code: string }>;

  /**
   * access token sent back when logging in
   */
  accessToken: string | null;

  /**
   * List of all organizations that user has access to
   */
  organizations: Organization[];

  /**
   * Currently selected selectedOrganization
   */
  selectedOrganization?: Organization;

  /**
   * Info about currently logged in user
   */
  me?: Me;

  /**
   * List of roles of current user
   */
  roles: string[] | undefined;

  isSelectingOrganization: boolean;
}

const initialState: AuthState = {
  isAuthenticating: false,
  isAuthenticated: false,
  errors: [],
  accessToken: null,
  organizations: [],
  selectedOrganization: undefined,
  me: undefined,
  roles: undefined,
  isSelectingOrganization: false,
};

type SupportedActions =
  | authActions.AuthLoginAction
  | authActions.AuthAutologinSuccessAction
  | authActions.AuthLoginSuccessAction
  | authActions.AuthLoginFailAction
  | authActions.AuthLogoutAction
  | authActions.SelectOrganizationAction
  | authActions.SelectOrganizationFailAction
  | authActions.SelectOrganizationSuccessAction;

export const authReducer: Reducer<AuthState> = (
  state = initialState,
  action: SupportedActions
): AuthState => {
  switch (action.type) {
    case authActions.AUTH_LOGIN: {
      return {
        ...state,
        isAuthenticating: true,
      };
    }
    case authActions.AUTH_LOGIN_SUCCESS:
    case authActions.AUTH_AUTOLOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticated: true,
        accessToken: action.accessToken,
        organizations: action.organizations,
        selectedOrganization: undefined,
        me: action.me,
        errors: [],
        roles: action.roles,
      };
    }
    case authActions.AUTH_LOGIN_FAIL: {
      return {
        ...state,
        isAuthenticating: false,
        isAuthenticated: false,
        errors: action.reasons,
      };
    }
    case authActions.AUTH_LOGOUT: {
      return {
        ...state,
        isAuthenticated: false,
        accessToken: null,
      };
    }
    case authActions.SELECT_ORGANIZATION: {
      return {
        ...state,
        isSelectingOrganization: true,
      };
    }
    case authActions.SELECT_ORGANIZATION_FAIL: {
      return {
        ...state,
        isSelectingOrganization: false,
      };
    }
    case authActions.SELECT_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        selectedOrganization: { ...action.organization },
        isSelectingOrganization: false,
      };
    }
    default: {
      return state;
    }
  }
};
